import React from "react";
import { useHistory } from 'react-router-dom';

import Button from "components/Button";

import {
    PageWrapper,
    HeroSection,
    HeroTitle,
    HeroSubtitle,
    PlansGrid,
    PlanCard,
    PopularBadge,
    PlanTitle,
    PlanSubtitle,
    PriceWrapper,
    OriginalPrice,
    DiscountBadge,
    Price,
    PriceUnit,
    FeaturesList,
    PlanCTA,
    ComparisonNote,
    FooterCTA,
    FooterCTAText
} from './styled';

// Dados dos planos — fonte única de verdade
// Ordem proposital: Mensal (popular) primeiro, depois Anual (melhor custo) e Cartão Pré-Pago no final
const plansData = [
    {
        id: 'monthly',
        title: 'Premium Mensal',
        subtitle: 'Para conversar à vontade',
        price: 'R$ 24,90',
        priceUnit: '/mês',
        isPopular: true,
        features: [
            'Mensagens ilimitadas',
            'Todos os 4 personagens (Salomão, Davi, Ester e Daniel)',
            'Modo Bate-papo + Modo Praticar Idiomas',
            'Mais de 10 idiomas disponíveis',
            'Suporte por WhatsApp',
            'Cancele quando quiser'
        ],
        buttonText: 'Assinar agora',
        buttonVariant: 'primary',
        action: 'monthly'
    },
    {
        id: 'yearly',
        title: 'Premium Anual',
        subtitle: 'Melhor custo-benefício',
        originalPrice: 'R$ 298,80',
        discount: '40% OFF',
        price: 'R$ 179,90',
        priceUnit: '/ano',
        equivalent: 'Equivale a R$ 14,99/mês',
        features: [
            'Tudo do Premium Mensal',
            'Equivale a R$ 14,99/mês',
            'Economia de R$ 118,90 por ano',
            'Acesso antecipado a novos personagens',
            'Suporte prioritário via WhatsApp'
        ],
        buttonText: 'Economizar 40%',
        buttonVariant: 'primary',
        action: 'yearly'
    },
    {
        id: 'giftcard',
        title: 'Cartão Pré-Pago',
        subtitle: 'Para presentear ou pagar à vista',
        price: 'Pague uma vez',
        priceUnit: '· sem renovação',
        features: [
            'Acesso completo durante o período do cartão',
            'Sem cobrança recorrente — paga uma vez e pronto',
            'Todos os 4 personagens e idiomas',
            'Ótima opção para presentear alguém',
            'Pode ser usado por qualquer pessoa com o código'
        ],
        buttonText: 'Usar Cartão Pré-Pago',
        buttonVariant: 'primary',
        action: 'giftcard'
    }
];

export default function OnPlanos() {

    const history = useHistory();
    const navigate = to => history.push(`/${ to }`);

    const handlePlanClick = (action) => {
        if (action === 'giftcard') {
            // Cartão Pré-Pago — fluxo específico (signGiftCard no Register)
            navigate('register?provider=giftcard');
        } else {
            // Premium (mensal/anual) — fluxo padrão de assinatura com cartão de crédito
            navigate('register');
        }
    };

    return (
        <PageWrapper>
            <HeroSection>
                <HeroTitle>Escolha o plano ideal para você</HeroTitle>
                <HeroSubtitle>
                    Conversas ilimitadas com todos os personagens. Cancele quando quiser.
                </HeroSubtitle>
            </HeroSection>

            <PlansGrid>
                {plansData.map((plan) => (
                    <PlanCard key={plan.id} popular={plan.isPopular}>
                        {plan.isPopular && <PopularBadge>MAIS POPULAR</PopularBadge>}

                        <PlanTitle>{plan.title}</PlanTitle>
                        <PlanSubtitle>{plan.subtitle}</PlanSubtitle>

                        {plan.discount && (
                            <DiscountBadge>{plan.discount}</DiscountBadge>
                        )}

                        <PriceWrapper>
                            {plan.originalPrice && (
                                <OriginalPrice>{plan.originalPrice}</OriginalPrice>
                            )}
                            <Price>
                                {plan.price}
                                <PriceUnit>{plan.priceUnit}</PriceUnit>
                            </Price>
                        </PriceWrapper>

                        <FeaturesList>
                            {plan.features.map((feature, idx) => (
                                <li key={idx}>{feature}</li>
                            ))}
                        </FeaturesList>

                        <PlanCTA>
                            {plan.buttonVariant === 'secondary' ? (
                                <Button secondary onClick={() => handlePlanClick(plan.action)}>
                                    {plan.buttonText}
                                </Button>
                            ) : (
                                <Button primary onClick={() => handlePlanClick(plan.action)}>
                                    {plan.buttonText}
                                </Button>
                            )}
                        </PlanCTA>
                    </PlanCard>
                ))}
            </PlansGrid>

            <ComparisonNote>
                💡 Todos os planos dão acesso completo aos 4 personagens, aos 10+ idiomas e a conversas ilimitadas. A diferença está apenas na forma de pagamento.
            </ComparisonNote>

            <FooterCTA>
                <FooterCTAText>
                    Ainda com dúvida? Fale com a gente pelo WhatsApp.
                </FooterCTAText>
                <a
                    href="https://wa.me/5516982026554?text=Tenho%20d%C3%BAvidas%20sobre%20os%20planos%20do%20TiqChat"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: 'none' }}
                >
                    <Button white>Falar no WhatsApp</Button>
                </a>
            </FooterCTA>
        </PageWrapper>
    );
}
